var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "info-2_svg__a",
    d: "M8 1.455a6.545 6.545 0 100 13.09 6.545 6.545 0 100-13.09zm-.09 2.4a.979.979 0 11-.979.978.98.98 0 01.98-.978zm1.528 8.29H6.562V10.98h.64V7.59h-.058a.583.583 0 010-1.164h1.658v4.555h.635v1.165h.001z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#777",
    xlinkHref: "#info-2_svg__a",
    transform: "translate(-1.264 -1)",
    fillRule: "evenodd"
  })));
}
export default SvgInfo2;